/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Create_New_FolderInputs */

const en_audio_create_new_folder = /** @type {(inputs: Audio_Create_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new folder`)
};

const es_audio_create_new_folder = /** @type {(inputs: Audio_Create_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva carpeta`)
};

/**
* | output |
* | --- |
* | "Create new folder" |
*
* @param {Audio_Create_New_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_create_new_folder = /** @type {((inputs?: Audio_Create_New_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Create_New_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_create_new_folder(inputs)
	return en_audio_create_new_folder(inputs)
});